import { select_default_value_all } from "./Constants";

export const setFilterOptions = (responseArray, key) => {
    let regions = new Set()
    let filterRegions = []
    responseArray?.forEach((item) => {
      regions.add(item[key])
    })
    regions.forEach((item) => {
      filterRegions.push({ label :item , value :item})
    })
    return filterRegions
  }

  export const setFilterOptionsWithAll = (responseArray, key) => {
    let filterRegions = setFilterOptions(responseArray, key)
    filterRegions.push(select_default_value_all)
    return filterRegions
  }

  export const convertEpochToPST = (epoch) => {
    let date = new Date(epoch)
    return date.toLocaleString('en-US', {
      timeZone: 'America/Los_Angeles',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZoneName: 'short'
    })
  }

  // Formats an epoch in the viewer's own local timezone (e.g. IST for a user in India),
  // rather than forcing PST/PDT. Omitting the timeZone option lets the browser use its local zone.
  // No timeZoneName is included in the cell text; columns signal the local zone via a "(Local)"
  // suffix in their header instead (matching the AWS Glue run-history styling).
  export const convertEpochToLocal = (epoch) => {
    let date = new Date(epoch)
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    })
  }